module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "logo"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.linkHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/medibox.png")
    }
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "parent"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'askbox'
      },
      "active-class": "active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_vm._v("\n                Solicitar BOX\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "parent"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bidbox_internal'
      },
      "active-class": "active",
      "exact": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggle($event)
      }
    }
  }, [_vm._v("\n                Ofrecer BOX\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "language"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('md-icon', [_vm._v("language")])], 1), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "language",
      "id": "language"
    },
    on: {
      "change": _vm.updateLang
    },
    model: {
      value: (_vm.lang),
      callback: function($$v) {
        _vm.lang = $$v
      },
      expression: "lang"
    }
  }, _vm._l((_vm.languages), function(language) {
    return _c('md-option', {
      key: language.id,
      attrs: {
        "value": language.code
      }
    }, [_vm._v(_vm._s(language.name))])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67cd3e62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/doctor/partials/Sidebar.vue
// module id = 595
// module chunks = 1